import Service from "../../AuthService";
const ReportReportProduct = {
    getReportProduct(page) {
        return Service.get("/product-report?page="+page);
    },
    showReportProduct(id) {
        return Service.get("/product-report/" + id);
    },
    updateReportProduct(id, data) {
        return Service.put("/product-report/" + id, data);
    },
    createReportProduct(data) {
        return Service.post("/product-report", data);
    },
    deleteReportProduct(id) {
        return Service.delete("/product-report/" + id);
    },
    searchReportProduct(page,code, date, machine) {
        return Service.post(
            "/search-product-report?page=" +
                page +
                "&code=" +
                code +
                "&date=" +
                date +
                "&machine=" +
                machine
        );
    },
    getSheetByProduct(code){
        return Service.post("/getSheetByProduct", code);
    },

    //machine percent
    getMachinePercent(){
        return Service.get("/machine-percent");
    },
    createMachinePercent(data){
        return Service.post("/machine-percent", data);
    },
    updateMachinePercent(id,data){
        return Service.put("/machine-percent/"+id,data);
    }
};
export default ReportReportProduct;
